<template>
  <div>
    <el-dialog title="联系我们" :visible.sync="detailVisible" :close-on-click-modal="false" append-to-body custom-class="talent-detail-dialog">
      <!-- 客服网格列表 -->
      <div class="grid-container">
        <div v-for="(service, index) in kefuList" :key="index" class="customer-service-card" @click="sendWeixin(service)">
          <div class="avatar-container">
            <img :src="service.pic" :alt="service.title" class="avatar" />
          </div>
          <h3 class="name">{{ service.title }}</h3>

          <div class="phone">
            <i class="fas fa-phone-alt"></i>
            {{ service.mobilephone }}
          </div>
          <div class="action-buttons">
            <el-button type="success" size="small" icon="el-icon-comment" class="action-button" @click.stop="sendWeixin(service)">加微信</el-button>
          </div>
        </div>
      </div>

      <!-- 无数据提示 -->
      <div v-if="kefuList.length === 0" style="text-align: center; padding: 50px 0">
        <el-empty description="没有找到匹配的客服人员"></el-empty>
      </div>
    </el-dialog>
    <!-- 二维码弹窗 -->
    <el-dialog title="微信二维码" :visible.sync="detailVisible1" width="auto" :close-on-click-modal="false" append-to-body custom-class="talent-detail-dialog1">
      <img :src="qsImg" style="width: 200px" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 弹窗控制
      detailVisible: false,
      detailVisible1: false,
      qsImg: ''
    };
  },
  computed: {
    kefuList() {
      if (localStorage.getItem('kefu_list')) {
        let _list = JSON.parse(localStorage.getItem('kefu_list'));
        _list.forEach((element) => {
          element.src = window.global.BaseUrl + element.src;
          element.pic = window.global.BaseUrl + element.pic;
        });
        return _list;
      }
      return [];
    }
  },
  mounted() {},
  methods: {
    open() {
      this.detailVisible = true;
    },
    sendWeixin(item) {
      this.qsImg = item.src;
      this.detailVisible1 = true;
    }
  }
};
</script>
<style scoped>
.grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 25px;
}
.customer-service-card {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 20px;
  cursor: pointer;
}
.customer-service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}
.avatar-container {
  position: relative;
  margin-bottom: 8px;
}
.avatar {
  width: 50px;
  object-fit: cover;
}
.action-buttons {
  display: flex;
  gap: 10px;
  width: 100%;
  justify-content: center;
}
.action-button {
  flex: 1;
  max-width: 100px;
}
.name {
  font-size: 15px;
  font-weight: 500;
  color: #1f2d3d;
  margin-bottom: 5px;
}
.phone {
  color: #8392a5;
  font-size: 14px;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
}
.phone i {
  margin-right: 5px;
  font-size: 14px;
}
::v-deep .talent-detail-dialog {
  width: 38% !important;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .grid-container {
    grid-template-columns: repeat(2, 1fr);
  }
  ::v-deep .talent-detail-dialog {
    width: 95% !important;
  }
}
</style>
